import React from "react";
import "./App.css";

const Modal = ({
  name,
  trailer,
  description,
  onClickFunction,
  onClickFunction2,
  isOpen,
  isFavourites,
}) => {
  console.log(trailer, name);
  return (
    <div
      style={{
        display: `${isOpen ? "flex" : "none"}`,
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        width: "80%",
        margin: "auto",
        top: "0",
        left: "0",
        right: "0",
        bottom: "0",
      }}
    >
      <dialog style={{ borderRadius: "20px" }} open={isOpen}>
        <h2>{name}</h2>
        <iframe
          width="560"
          height="315"
          src={trailer}
          title="Trailer"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
        <p>{description}</p>
        <button className="close" onClick={() => onClickFunction()}>
          X
        </button>
        <button onClick={() => onClickFunction2()}>
          {!isFavourites ? "Add to Favourites" : "Delete from Favouritess"}
        </button>
      </dialog>
    </div>
  );
};

export default Modal;
